import axios from "axios";

// Option 1: Use environment variable with fallback
const baseURL =
  process.env.REACT_APP_BASE_URL ||
  "https://moloyal.com/test/mosave/script/api";

// Option 2: Hardcode for testing (temporary)
// const baseURL = "https://moloyal.com/test/mosave/script/api";

export const signup = async ({
  firstname,
  lastname,
  email,
  password,
  agentphone,
  country,
}) => {
  try {
    console.log("Making request to:", `${baseURL}/agent/register`);
    const { data } = await axios.post(`${baseURL}/agent/register`, {
      firstname,
      lastname,
      email,
      password,
      agentphone,
      country,
    });
    return data;
  } catch (error) {
    if (error.response && error.response.data.message)
      throw new Error(error.response.data.message);
    throw new Error(error.message);
  }
};

export const login = async ({ userid, password }) => {
  try {
    const response = await axios.post(`${baseURL}/agent/login`, {
      userid,
      password,
    });

    if (response.data.error) {
      throw new Error(response.data.message || "An error occurred");
    }

    return response.data;
  } catch (error) {
    throw new Error(error.message || "An error occurred");
  }
};
